<template>
  <v-card class="create-contract">
    <v-card-title>
      {{ $t('contract.create_title') }}
    </v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <v-text-field outlined
                      :label="$t('contract.id')"
                      v-model="result.id"
                      :rules="requiredRules"></v-text-field>
        <v-text-field outlined
                      :label="$t('contract.name')"
                      v-model="result.name"
                      :rules="requiredRules"></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit', false)"
             depressed
             large>
        {{ $t('cancel') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="$refs.form.validate() && save()"
             depressed
             large>
        {{ $t('ok') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {ref} from "@vue/composition-api";
import {ACTION_TYPES} from "@/store/types";

export default {
  name: 'CreateContractDialog',
  setup(props, {root, emit}) {
    const requiredRules = ref([
      value => !!value || root.$t('rules.required'),
    ]);

    const result = ref({
      id: '',
      name: '',
    })

    const save = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/contract/create/',
        params: {
          ...result.value,
        }
      });

      if (response.body.success) {
        emit('submit', response.body.contract.id)
      }
    }

    return {
      requiredRules,
      result,
      save,
    }
  },
}
</script>
